export default "__VITE_ASSET__c9de765e__"